import { render, staticRenderFns } from "./branch.vue?vue&type=template&id=6ad4b9eb"
import script from "./branch.vue?vue&type=script&lang=js"
export * from "./branch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports